// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = '/vote/2022project/q4/2022light_disk/controller.php?enews=';


export const cardList = (unionId: string) => {
  if (!unionId || unionId === null || unionId === 'null') {
    return http.get(`${urlPrefix}card-list`);
  } else {
    return http.get(`${urlPrefix}card-list&unionid=` + unionId);
  }
};

export const userList = (unionId: string) => {
  if (!unionId || unionId === null || unionId === 'null') {
    return http.get(`${urlPrefix}user-list`);
  } else {
    return http.get(`${urlPrefix}user-list&unionid=` + unionId);
  }
};
export const checkUserExist = (unionId: string) => {
  return http.get(`${urlPrefix}check-user-exist&unionid=` + unionId);
};
export const userPrize = (unionId: string) => {
  if (!unionId || unionId === null || unionId === 'null') {
    return http.get(`${urlPrefix}userPrize`);
  } else {
    return http.get(`${urlPrefix}userPrize&unionid=` + unionId);
  }
};

export const prizeConfig = () => {
  return http.get(`${urlPrefix}prizeConfig`);
};

export const luckDrawNum = (unionId: string) => {
  if (!unionId || unionId === null || unionId === 'null') {
    return http.get(`${urlPrefix}luckDrawNum`);
  } else {
    return http.get(`${urlPrefix}luckDrawNum&unionid=` + unionId);
  }
};

export const rank = (unionId: string, type: number, page: number) => {
  if (!unionId || unionId === null || unionId === 'null') {
    return http.get(`${urlPrefix}rank&type=` + type + '&page=' + page);
  } else {
    return http.get(`${urlPrefix}rank&type=` + type + '&page=' + page + '&unionid=' + unionId);
  }
};

export const rankAll = (type: number) => {
  return http.get(`${urlPrefix}get-rank-history&type=` + type);
};

export const rankCity = (cityname: string) => {//总区县排名
  return http.get(`${urlPrefix}get-city-history&cityname=` + cityname);
};
export const rankCitynow = (cityname: string) => {//本期区县排名
  return http.get(`${urlPrefix}get-city-trun&cityname=` + cityname);
};


export const shareList = (unionId: string, id: string, udid: string) => {
  if (!unionId || unionId === null || unionId === 'null') {
    if (!udid || udid === null || udid === 'null') {
      return http.get(`${urlPrefix}share-list&id=` + id);
    } else {
      return http.get(`${urlPrefix}share-list&id=` + id + '&udid=' + udid);
    }
  } else {
    if (!udid || udid === null || udid === 'null') {
      return http.get(`${urlPrefix}share-list&unionid=` + unionId + '&id=' + id);
    } else {
      return http.get(`${urlPrefix}share-list&unionid=` + unionId + '&id=' + id + '&udid=' + udid);
    }
  }
};

export const userMessage = (unionId: string) => {
  if (!unionId || unionId === null || unionId === 'null') {
    return http.get(`${urlPrefix}user-message`);
  } else {
    return http.get(`${urlPrefix}user-message&unionid=` + unionId);
  }
};

export const nowPrize = () => {
  return http.get(`${urlPrefix}nowPrize`);
};

const vote = (data: any) => {
  return http.post(`${urlPrefix}vote`, qs.stringify(data));
};

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

const getCityList = () => {
  return http.get('/vote/2022project/q4/2022light_disk/controller.php?enews=getAreas');
};


const getList = (page: number, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search: keyword,
    },
  });
};
const userCheck = (unionid: string) => {
  if (!unionid || unionid === null || unionid === 'null') {
    return http.get(`${urlPrefix}user-check`);
  } else {
    return http.get(`${urlPrefix}user-check&unionid=` + unionid);
  }
};
const luckDraw = (unionid: string) => {
  if (!unionid || unionid === null || unionid === 'null') {
    return http.get(`${urlPrefix}luckDraw`);
  } else {
    return http.get(`${urlPrefix}luckDraw&unionid=` + unionid);
  }
};

const messageSave = (data: any) => {
  return http.post(`${urlPrefix}messageSave`, qs.stringify(data));
};

const cover = (data: any) => {
  const qsData = qs.stringify(data);
  if (!data.unionid || data.unionid === null || data.unionid === 'null') {
    return http.post(`${urlPrefix}cover`, qsData, { headers: {} });
  } else {
    return http.post(`${urlPrefix}cover&unionid=${data.unionid}`, qsData, { headers: {} });
  }
};

const detail = (id: any) => {
  return http.get(`${urlPrefix}detail&id=` + id);
};

const save = (data: any) => {
  const qsData = qs.stringify(data);
  if (!data.unionid || data.unionid === null || data.unionid === 'null') {
    return http.post(`${urlPrefix}save`, qsData, { headers: {} });
  } else {
    return http.post(`${urlPrefix}save&unionid=${data.unionid}`, qsData, { headers: {} });
  }
};
export { getBaseInfo, getRule, getList, detail, getCityList, luckDraw, messageSave, save, userCheck, cover };
